'use strict';

/**
 * Api Response Handler (wdApiResponseHandler.js).
 * API Response Handler.
 *
 * @author rsweeney@webduct.com <rsweeney@webduct.com>
 * @copyright 2018 Webduct Systems Inc.
 *
 * @version
 * 1.0.0 LIBENV-1 Initialize environment library
 *
 */
angular.module('wd.handler.response.api', [])
    .factory('wdApiResponseHandler',
        function () {

            return new WebductApiResponseHandler();

        });
// EOF